module.exports = __webpack_public_path__ + "img/02_Grundlagen.1138d744.svg";